import { getLicenseType, getLicenseTermById } from 'Settings/pricing-options';

export const initializeList = (name, id) => dispatch => {
  dispatch({
    type: 'INITIALIZE_LIST',
    id,
    name,
  });
};

export const clearNewIds = id => dispatch => {
  dispatch({
    type: 'CLEAR_NEW_USER_IDS_FROM_LIST',
    id,
  });
};

export const updateListSearchFilter = (
  value,
  listId,
  itemFilterCallback
) => dispatch => {
  dispatch({
    type: 'UPDATE_LIST_SEARCH_FILTER',
    value,
    itemFilterCallback,
    id: listId,
  });
};

export const filterStatsByLicense = (filter, id) => dispatch => {
  let callback;
  switch (filter) {
    case 'deactivated':
    case 'expired':
      callback = item => item.school_deactivated;
      break;
    case 'active':
      callback = item => !item.school_deactivated;
      break;
    case 'trial':
    case 'paid': {
      const matchString = filter === 'paid' ? 'annual' : filter;
      callback = item =>
        item.license_type &&
        getLicenseTermById[item.license_type] === matchString &&
        !item.school_deactivated;
      break;
    }
    case 'school_license':
    case 'homeschool_license':
    case 'classroom_license':
      callback = item =>
        item.license_type &&
        !item.school_deactivated &&
        getLicenseType[item.license_type] === filter.replace('_license', '');
      break;
    case 'none':
      return dispatch({
        type: 'CLEAR_LIST_FILTER',
        id,
      });
    default:
      return false;
  }
  dispatch({
    type: 'UPDATE_LIST_FILTER',
    callback,
    filter,
    id,
  });
  return true;
};

export const updateUserListSearch = (value, listId) => dispatch => {
  const itemFilterCallback = (item, term) =>
    item.given_name.toLowerCase().includes(term) ||
    item.family_name.toLowerCase().includes(term) ||
    item.auth_info.username.toLowerCase().includes(term);
  dispatch(updateListSearchFilter(value, listId, itemFilterCallback));
};

export const updateStatsListSearch = (value, listId) => dispatch => {
  const itemFilterCallback = (item, term) =>
    (item.school_name && item.school_name.toLowerCase().includes(term)) ||
    (item.admin_email && item.admin_email.toLowerCase().includes(term));
  dispatch(updateListSearchFilter(value, listId, itemFilterCallback));
};

export const clearListSearchFilter = listId => dispatch => {
  dispatch({
    type: 'CLEAR_LIST_SEARCH_FILTER',
    id: listId,
  });
};

export const clearListMessage = id => dispatch => {
  dispatch({
    type: 'CLEAR_USER_GROUP_MESSAGE',
    id,
  });
};

export const clearAllListMessages = () => dispatch => {
  dispatch({
    type: 'CLEAR_ALL_LIST_MESSAGES',
  });
};

export const updateSortColumn = (key, id) => dispatch => {
  dispatch({
    type: 'UPDATE_LIST_SORT_COLUMN',
    key,
    id,
  });
};
